import { OrganizationUpdatedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/organization_events_pb';
import { Col } from '@rematter/ui-web';
import { DiffViewer, FieldDisplay, IDField } from '@rematter/ui-web';

type OrganizationUpdatedDetailProps = {
  event: OrganizationUpdatedEvent;
};

export const OrganizationUpdatedDetail = ({
  event,
}: OrganizationUpdatedDetailProps) => {
  const previous = event.previousOrganization;
  const current = event.updatedOrganization;

  if (!previous || !current) {
    return (
      <Col className="@OrganizationUpdatedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const diffs = [
    {
      field: 'name',
      label: 'Name',
      previous: previous.name,
      current: current.name,
    },
    {
      field: 'domain',
      label: 'Domain',
      previous: previous.domain,
      current: current.domain,
    },
    {
      field: 'timezone',
      label: 'Timezone',
      previous: previous.timezone?.name,
      current: current.timezone?.name,
    },
    {
      field: 'idpId',
      label: 'IDP ID',
      previous: previous.idpId,
      current: current.idpId,
    },
  ];

  return (
    <Col className="@OrganizationUpdatedDetail gap-3" gap3>
      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap2>
        <span className="text-xs font-medium text-neutral/60">
          Organization
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={current.id?.value} />
          <FieldDisplay label="Name" value={current.name} />
        </div>
      </Col>

      <Col className="rounded-md border border-neutral/10 bg-white p-3" gap1>
        <span className="mb-2 text-xs font-medium text-neutral/60">
          Changes
        </span>
        <DiffViewer diffs={diffs} previousLabel="Before" currentLabel="After" />
      </Col>
    </Col>
  );
};
